<template>
    <div class="free-trial-box">
        <span class="free-trial-box__title" v-html="$t('FreeTrialBox.try_our_platform')"></span>
        <span class="free-trial-box__description" v-html="$t('FreeTrialBox.seven_day_trial')"></span>
        <TotemButton :label="$t('FreeTrialBox.interested_button')" color="primary" />
    </div>
</template>

<script>

export default {
    name: 'free-trial-box'
}
</script>

<style lang="scss" scoped>
    .free-trial-box {
        border: 2px solid $lavender;
        border-radius: 10px;
        padding: 40px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 20px;
        margin: 0 1px 30px;
        width: 100%;

        [class*="mobile"] & {
            margin: 50px 0px 30px;
        }

        &__title {
            font-size: 2.2rem;
            font-family: PlusJakartaSans-Regular, sans-serif;
            color: $black;
        }

        &__description {
            font-size: 3.6rem;
            font-family: PPAgrandir-Medium, sans-serif;
            color: $lavender;
        }
    }
</style>
